import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './CookieBanner.css';

const STORAGE_KEY = 'cookie_consent_accepted';

/**
 * Cookie notice banner. Shown until user accepts; consent stored in localStorage.
 */
export default function CookieBanner() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const hiddenPaths = new Set([
    '/login',
    '/welcome',
    '/intake',
    '/organizer',
    '/es/regularizacion/success',
    '/register',
    '/signup/sso-details',
    '/signup/sso-contact',
  ]);

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY) !== 'true') setVisible(true);
    } catch {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'true');
    } catch {}
    setVisible(false);
  };

  if (!visible || hiddenPaths.has(pathname)) return null;

  return (
    <div className="mvp-cookie-banner" role="dialog" aria-label={t('cookie.title', 'Cookie notice')}>
      <p className="mvp-cookie-banner-text">
        {t('cookie.text', 'We use cookies to provide the service and improve your experience. By continuing you agree to our use of cookies.')}
        {' '}
        <Link to="/privacy" className="mvp-cookie-banner-link">{t('legal.privacy', 'Privacy')}</Link>
        {' · '}
        <Link to="/cookie-policy" className="mvp-cookie-banner-link">{t('legal.cookiePolicy', 'Cookie policy')}</Link>
      </p>
      <button type="button" className="mvp-cookie-banner-accept" onClick={accept}>
        {t('cookie.accept', 'Accept')}
      </button>
    </div>
  );
}
